module.exports = __webpack_public_path__ + "static/media/twitterGray.06af6071.svg";